import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'datetimeFilterFormat',
    standalone: false
})
export class DateTimeFilterFormatPipe implements PipeTransform {
   transform(value: Date | string): string {
      const date = typeof value === 'string' ? new Date(value) : value;
      return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)} ${(
         '0' + date.getHours()
      ).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}`;
   }
   transformUTC(value: Date | string): string {
      const date = typeof value === 'string' ? new Date(value) : value;
      return `${date.getUTCFullYear()}-${('0' + (date.getUTCMonth() + 1)).slice(-2)}-${('0' + date.getUTCDate()).slice(
         -2
      )} ${('0' + date.getUTCHours()).slice(-2)}:${('0' + date.getUTCMinutes()).slice(-2)}`;
   }
}
